module.exports = __webpack_public_path__ + "Employer Notice 08_28_2024.pdf";